import axios from 'axios'
import qs from 'qs'
function getParameter(data) {
    var parameter = '?'
    for (var item in data) {
        parameter = parameter + item + '=' + data[item] + '&'
    }
    parameter=parameter.substring(0,parameter.length-1)
    return parameter
}
//作品年份
export function workYears(data) {
    return axios({
        url: `/api/web/workYears${getParameter(data)}`,
        method: 'get'
    })
}
//作品年份
export function workYearsMobile(data) {
    return axios({
        url: `/api/web/workYears/mobile${getParameter(data)}`,
        method: 'get'
    })
}
//作品
export function findWords(data) {
    return axios({
        url: `/api/web/findWords${getParameter(data)}`,
        method: 'get'
    })
}

export function findNews(data) {
    return axios({
        url: `/api/web/findNews${getParameter(data)}`,
        method: 'get'
    })
}

export function findExhibitions(data) {
    return axios({
        url: `/api/web/findExhibitions${getParameter(data)}`,
        method: 'get'
    })
}

export function site(data) {
    return axios({
        url: `/api/web/site`,
        method: 'get'
    })
}

export function resume(data) {
    return axios({
        url: `/api/web/resume`,
        method: 'get'
    })
}

export function resetPass(data) {
    return axios({
        url: `/api/user/resetPass`,
        method: 'post',
        data: qs.stringify(data)
    })
}